import { CollaboratorInterface } from '../collaborators/types';

/*
 * Action Types
 */
export enum GroupsTypes {
  LIST_GROUPS_REQUEST = '@collaboratorsGroups/LIST_GROUPS_REQUEST',
  LIST_GROUPS_SUCCESS = '@collaboratorsGroups/LIST_GROUPS_SUCCESS',
  LIST_GROUPS_FAILURE = '@collaboratorsGroups/LIST_GROUPS_FAILURE',

  GET_GROUP_REQUEST = '@collaboratorsGroups/GET_GROUP_REQUEST',
  GET_GROUP_SUCCESS = '@collaboratorsGroups/GET_GROUP_SUCCESS',
  GET_GROUP_FAILURE = '@collaboratorsGroups/GET_GROUP_FAILURE',

  FILTER_GROUPS_REQUEST = '@collaboratorsGroups/FILTER_GROUPS_REQUEST',
  FILTER_GROUPS_SUCCESS = '@collaboratorsGroups/FILTER_GROUPS_SUCCESS',
  FILTER_GROUPS_FAILURE = '@collaboratorsGroups/FILTER_GROUPS_FAILURE',

  CREATE_GROUP_REQUEST = '@collaboratorsGroups/CREATE_GROUP_REQUEST',
  CREATE_GROUP_SUCCESS = '@collaboratorsGroups/CREATE_GROUP_SUCCESS',
  CREATE_GROUP_FAILURE = '@collaboratorsGroups/CREATE_GROUP_FAILURE',

  UPDATE_GROUP_REQUEST = '@collaboratorsGroups/UPDATE_GROUP_REQUEST',
  UPDATE_GROUP_SUCCESS = '@collaboratorsGroups/UPDATE_GROUP_SUCCESS',
  UPDATE_GROUP_FAILURE = '@collaboratorsGroups/UPDATE_GROUP_FAILURE',

  DELETE_GROUP_REQUEST = '@collaboratorsGroups/DELETE_GROUP_REQUEST',
  DELETE_GROUP_SUCCESS = '@collaboratorsGroups/DELETE_GROUP_SUCCESS',
  DELETE_GROUP_FAILURE = '@collaboratorsGroups/DELETE_GROUP_FAILURE',
}

/*
 * Data types
 */
export interface GroupInterface {
  id: string;
  name: string;
  companyId: string;
  users: CollaboratorInterface[];
  createdAt?: string;
  updatedAt?: string;
}

/*
 * State type
 */
export interface CollaboratorsGroupsState {
  /* readonly filteredGroups: GroupInterface[]; */
  readonly groupsList: GroupInterface[];
  readonly groupData: GroupInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
